export default function stopVideo() {

    $('.modal__video').each(function () {
       $(this).find('iframe').attr('src', function () {
           let src = $(this).attr('src');
           return src + '?rel=0';
       });
    });

    $('.modal--video').on('modal:opened', function (ev) {
        // alert('hello')
        // var symbol = $("iframe")[0].src.indexOf("?") > -1 ? "&" : "?";
        // //modify source to autoplay and start video
        // $("iframe")[0].src += symbol + "autoplay=1";
        // $("iframe")[0].src += "?autoplay=1";
        // $(this)[0].src += "&autoplay=1";
        $(this).find('iframe')[0].src += '&autoplay=1';
        ev.preventDefault();
    });
    $('.modal--video').on('modal:closed', function (ev) {
        // $('iframe')[0].src.replace('&autoplay=1', '&autoplay=0');
        // ev.preventDefault();
        $('.modal__video iframe').each(function(){
            this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
        });
        // let iframes = document.getElementsByTagName("iframe");
        let iframes = $('iframe');
        if (iframes != null) {
            for (var i = 0; i < iframes.length; i++) {
                iframes[i].src = iframes[i].src.replace('&autoplay=1', '');
            }
        }
    });

    // $('.modal__close, .modal-wrap__bg').click(function(){
    //     // $('.modal__video iframe').each(function(){
    //     //     this.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
    //     // });
    //     // // let iframes = document.getElementsByTagName("iframe");
    //     // let iframes = $('iframe');
    //     // if (iframes != null) {
    //     //     for (var i = 0; i < iframes.length; i++) {
    //     //         iframes[i].src = iframes[i].src;
    //     //     }
    //     // }
    // });
}